/**
 * @generated SignedSource<<909c7f16b9024e04b589034f49bfef8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedQuantitySelect_item$data = {
  readonly defaultSkuId: string | null;
  readonly isDeleted: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly isRingItem: boolean | null;
  readonly isSold: boolean | null;
  readonly seller: {
    readonly status: string | null;
  } | null;
  readonly skus: ReadonlyArray<{
    readonly hasUnlimitedQuantity: boolean | null;
    readonly quantity: number | null;
    readonly quantitySelectOptions: ReadonlyArray<{
      readonly label: string | null;
      readonly value: number | null;
    } | null> | null;
    readonly serviceId: string | null;
    readonly setSize: number | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedQuantitySelect_item";
};
export type PdpSharedQuantitySelect_item$key = {
  readonly " $data"?: PdpSharedQuantitySelect_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedQuantitySelect_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedQuantitySelect_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSkuId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUnlimitedQuantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkuQuantityOption",
          "kind": "LinkedField",
          "name": "quantitySelectOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "setSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "dbd99a2a488881a39df9b1581bb204b8";

export default node;
